import React, { useEffect } from "react";

import { Spin, Alert } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { ResultSet } from "@cubejs-client/core";
import { ResultSetRenderer } from "../../features/reports/GeneratedBuilder";
import DashboardItem from "../../components/reports/DashboardItem";
import { loadPage } from "./dashboardSlice";
import { useReportQuery } from "../../hooks";
import { Row, Col, Card } from "antd";
import styled from "styled-components";
import _ from "lodash";

const DashboardWrapper = styled.div`
  height: calc(100vh - 64px);
  overflow: auto;
  padding: 10px;
  .wrap {
  }
`;

const ChartItem = ({ item }) => {
  const query = useReportQuery(item.vizState.id);
  if (query.resultSet) {
    query.resultSet = new ResultSet(query.resultSet);
  }
  return (
    <ResultSetRenderer
      {...item.vizState}
      name={item.name}
      resultSet={query.resultSet}
    />
  );
};

const DashboardPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadPage({ current: 1 }));
  }, [dispatch]);

  const loading = useSelector(
    (state) => state.pendingActions["dashboards/loadPage"]
  );
  const { page, error } = useSelector((state) => state.dashboards);

  if (loading) {
    return <Spin />;
  }

  if (error) {
    return (
      <Alert
        message="Error occured while loading your query"
        description={error.toString()}
        type="error"
      />
    );
  }
  if (page.items.length === 0) {
    return null;
  }
  const items = page.items[0].items.map((i) => ({
    ...i,
    vizState: i.report,
    id: i.id + "",
    name: i.report.name,
  }));

  const grouped = _.groupBy(items, ({ layout }) => layout.y);
  const rowNumbers = _.sortBy(Object.keys(grouped));

  return (
    <DashboardWrapper>
      <div className="wrap">
        {rowNumbers
          .sort((a, b) => a - b)
          .map((r) => {
            const sum = _.sumBy(grouped[r], (r) => r.layout.w);
            return (
              <Row
                key={r}
                gutter={[8, 8]}
                style={{ paddingBottom: "8px" }}
                justify="space-between"
              >
                {grouped[r].map((item) => {
                  const isStatistics = item.vizState.chartType === "number";
                  return (
                    <Col span={(item.layout.w / sum) * 24} key={item.id}>
                      <Card
                        key={item.id}
                        styles={{
                          body:
                            item.vizState.chartType === "number"
                              ? {}
                              : { height: "400px" },
                        }}
                        title={!isStatistics && item.name}
                        style={{
                          height: "100%",
                          width: "100%",
                        }}
                      >
                        <ChartItem key={item.id} item={item} />
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            );
          })}
      </div>
    </DashboardWrapper>
  );
};

export default DashboardPage;
